module.exports = __webpack_public_path__ + "media/assets/images/authors/michele_minazzato-98c8264c7d609d97b3e7e8e6c015c480.jpg";